import { createSlice } from '@reduxjs/toolkit'

export const needAttentionSlice = createSlice(
    {
        name: 'needAttentionData',
        initialState: {
            studentDetails: {},
            chapterDetails: {},
            needAttention: {},
        },
        reducers: {

            studentId: (state, action) => {
                console.log("studentDetails", action.payload);
                state.studentDetails = action.payload
            },
            chapters: (state, action) => {
                console.log("studentDetails", action.payload);
                state.chapterDetails = action.payload
            },
            needAttentionDetails: (state, action) => {
                console.log("needAttention", action.payload);
                state.needAttention = action.payload
            }
        },
    },

)


export const { studentId, chapters, needAttentionDetails } = needAttentionSlice.actions

export default needAttentionSlice.reducer